export default {
    "0": "REGULAR",
    "1": "POPUP",
}